import * as React from 'react';

// REDUX
import { useAppSelector } from '../../../store';

// PACKAGES
import { Field, ErrorMessage, connect, FastField } from 'formik';

// COMPONENTS
import FileUpload from '../../../components/FileUpload';
import SingleSelect from '../../../components/SingleSelect';
import DateDayExpiryInput from '../../../components/DateDayExpiryInput';

// TYPES
interface WorkingWithChildrenFormTypes {
	formik?: any;
	index: number;
}

const WorkingWithChildrenForm: React.FC<WorkingWithChildrenFormTypes> = ({ formik, index }) => {
	// Get all States from Redux store
	const statesList = useAppSelector((state) => state?.lists.states);

	return (
		<div className="form-section-title">
			<div className="form-group two-col">
				<div className="sub-form-group">
					<label htmlFor={`accountCertification[${index}].state`}>State of registration</label>

					<Field
						children={() => {
							return (
								<>
									<SingleSelect
										name={`accountCertification[${index}].state`}
										options={statesList}
										onChange={(val: any) => formik.setFieldValue(`accountCertification[${index}].state`, val)}
										value={formik.values.accountCertification[index].state}
									/>
								</>
							);
						}}
					/>

					<ErrorMessage name={`accountCertification[${index}].state`}>
						{(error) => <div className="form-validation-error">{error}</div>}
					</ErrorMessage>
				</div>

				<div className="sub-form-group">
					<label htmlFor={`accountCertification[${index}].expiry`}>Expiry</label>

					<FastField
						className="form-control"
						name={`accountCertification[${index}].expiry`}
						children={() => (
							<DateDayExpiryInput
								dateTimeString={formik.values.accountCertification[index].expiry || ''}
								onChange={(val: any) => formik.setFieldValue(`accountCertification[${index}].expiry`, val)}
								excludePast={true}
							/>
						)}
					/>

					<ErrorMessage name={`accountCertification[${index}].expiry`}>
						{(error) => <div className="form-validation-error">{error}</div>}
					</ErrorMessage>
				</div>
			</div>

			<div className="form-group">
				<label htmlFor={`accountCertification[${index}].certificationNumber`}>Registration number</label>

				<FastField
					name={`accountCertification[${index}].certificationNumber`}
					className="form-control"
					type="text"
					placeholder=""
					onChange={formik.handleChange}
					value={formik.values.accountCertification[index].certificationNumber}
				/>

				<ErrorMessage name={`accountCertification[${index}].certificationNumber`}>
					{(error) => <div className="form-validation-error">{error}</div>}
				</ErrorMessage>
			</div>

			<div className="form-group">
				<Field
					children={() => {
						return (
							<>
								<FileUpload
									name={`accountCertification[${index}].attachments`}
									placeholder="Choose file..."
									onChange={(val: any[], files: any[]) => {
										formik.setFieldValue(`accountCertification[${index}].createAttachments`, val);
										formik.setFieldValue(`accountCertification[${index}].attachments`, files);
									}}
									multiple={true}
									label="Photo of registration"
									files={formik.values.accountCertification[index].attachments}
								/>
							</>
						);
					}}
				/>

				<ErrorMessage name={`accountCertification[${index}].createAttachments`}>
					{(error) => <div className="form-validation-error">{error}</div>}
				</ErrorMessage>
			</div>

			<div className="form-group acknowledge-container mbtom-0">
				<label className="form-control-checkbox">
					<Field
						name="userAcknowledgement"
						type="checkbox"
						onChange={() =>
							formik.setFieldValue(
								`accountCertification[${index}].userAcknowledgement`,
								!formik.values.accountCertification[index].userAcknowledgement
							)
						}
						checked={formik.values.accountCertification[index].userAcknowledgement}
					/>

					<span>
						I have notified the Working with Children Check authority that I am working or volunteering at this
						organisation.
					</span>
				</label>

				<ErrorMessage name={`accountCertification[${index}].userAcknowledgement`}>
					{(error) => <div className="form-validation-error">{error}</div>}
				</ErrorMessage>
			</div>
		</div>
	);
};

export default connect(WorkingWithChildrenForm);
